import { useRef, Fragment } from "react";
import { useDispatch } from "react-redux";
import { HistoryRound } from "../../commander/Types";
import { useAppSelector, useTranslation } from "../../hooks";
import { toggleHistoryRoundVisability } from "../../store/slices/history";
import classes from "../../styles/History.module.css";
import { formatCurrency, formatTime, Currency, getClasses } from "../../utils";
import Round from "./Round";
import Spinner from "../Spinner";
import ModalButton from "../buttons/ModalButton";
import Commander from "../../commander";

export const Message: React.FC<{
  visible: boolean;
  type: "error" | "info";
  content?: string | null;
}> = ({ visible, type, content }) => {
  if (!visible || !content) return null;

  return (
    <div className={getClasses(classes, "rounds-message", type)}>
      <div className={classes.inner}>{content}</div>
    </div>
  );
};

const Rounds: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const { history } = useAppSelector((state) => state);
  const table = useRef(null);
  const roundsArray = Object.values(history.rounds).sort(
    (a, b) => b.ts - a.ts
  ) as HistoryRound[];
  const toggleRound = (id: string, e: any) => {
    if (!e.target.classList.contains(classes["cell"])) return;

    const round = history.rounds[id];
    if (round.loading) {
      Commander.getHistoryRound(id);
    }
    dispatch(toggleHistoryRoundVisability(id));
  };

  const loadHandler = () => {
    if (history.page === -1) return;
    Commander.getHistoryRounds(history.page);
  };

  // return (
  //   <Message
  //     type="error"
  //     visible={true}
  //     content={"Error: " + useTranslation("historydemo")}
  //   />
  // );

  return (
    <Fragment>
      <Spinner name="history" visible={!history.initialized} full={true} />
      <Message
        type="error"
        visible={history.error}
        content={`Error: ${history.error?.message ?? ""}`}
      />
      <Message
        type="info"
        visible={
          roundsArray.length === 0 && history.initialized && !history.error
        }
        content={useTranslation("minhistory")}
      />
      <div
        ref={table}
        className={getClasses(
          classes,
          "table",
          roundsArray.length === 0 ? "hidden" : ""
        )}
      >
        <div className={getClasses(classes, "row", "title")}>
          <div className={classes.cell}>{useTranslation("rounddate")}</div>
          <div className={classes.cell}>{useTranslation("historybet")}</div>
          <div className={classes.cell}>{useTranslation("historypayout")}</div>
          <div className={classes.cell}>{useTranslation("balance")}</div>
        </div>

        {roundsArray.map((round: HistoryRound, i: number) => {
          const currency = {
            code: round.currencyId,
            symbol: round.currencySymbol,
          } as Currency;

          return (
            <div
              key={`row-${i}`}
              className={classes.row}
              onClick={toggleRound.bind(null, round.roundId)}
            >
              <div className={classes.cell}>{formatTime(round.created)}</div>
              <div className={classes.cell}>
                {formatCurrency(round.bet, currency)}
              </div>
              <div className={classes.cell}>
                {formatCurrency(round.win, currency)}
              </div>
              <div className={classes.cell}>
                {formatCurrency(round.closingBalance, currency)}
              </div>
              <Round id={round.roundId} />
            </div>
          );
        })}
      </div>
      <ModalButton
        available={
          history.initialized && history.page !== -1 && !history.loading
        }
        onClick={loadHandler}
      >
        {useTranslation("loadmore")}
      </ModalButton>
      <Spinner
        name="loadmore"
        visible={history.initialized && history.loading}
        full={false}
      />
    </Fragment>
  );
};

export default Rounds;
